import { motion } from 'framer-motion';
import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "Packshotstyle__Container",
  componentId: "sc-152e73f-0"
})([""]);
export const ActiveImage = styled.div.withConfig({
  displayName: "Packshotstyle__ActiveImage",
  componentId: "sc-152e73f-1"
})(["", " img{", "}"], {
  "aspectRatio": "1 / 1",
  "overflow": "hidden",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))"
}, {
  "height": "100%",
  "width": "100%",
  "objectFit": "contain"
});
export const PreviewWrapper = styled.div.withConfig({
  displayName: "Packshotstyle__PreviewWrapper",
  componentId: "sc-152e73f-2"
})(["", ""], {
  "position": "relative",
  "marginTop": "0.5rem"
});
export const PreviewImage = styled.div.withConfig({
  displayName: "Packshotstyle__PreviewImage",
  componentId: "sc-152e73f-3"
})(["", " img{", "}&.active{", "}"], {
  "aspectRatio": "1 / 1",
  "cursor": "pointer",
  "overflow": "hidden",
  "borderRadius": "0.5rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))"
}, {
  "height": "100% !important",
  "width": "100%",
  "objectFit": "contain"
}, {
  "borderWidth": "2px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(206 14 45 / var(--tw-border-opacity, 1))"
});
export const SlideArrow = styled(motion.div).withConfig({
  displayName: "Packshotstyle__SlideArrow",
  componentId: "sc-152e73f-4"
})(["", " &.arrow-left{", "}&.arrow-right{", "}"], {
  "position": "absolute",
  "top": "50%",
  "zIndex": "10",
  "--tw-translate-y": "-50%",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
  "--tw-translate-x": "0px",
  "cursor": "pointer",
  "userSelect": "none",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(23 23 23 / var(--tw-bg-opacity, 1))",
  "padding": "0.375rem"
}, {
  "--tw-translate-x": "-50%",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
}, {
  "right": "0px",
  "--tw-translate-x": "50%",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))"
});